export interface EventDay {
  id: string;
  label: string;
  date: string;
  weekday: string;
}

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;

export function buildEventDays(startDate: Date, endDate: Date): EventDay[] {
  const days: EventDay[] = [];
  const cur = new Date(startDate);
  cur.setHours(0, 0, 0, 0);
  const end = new Date(endDate);
  end.setHours(0, 0, 0, 0);
  let index = 1;
  while (cur <= end) {
    const iso = cur.toISOString().slice(0, 10);
    days.push({
      id: `d${index}`,
      label: `Day ${index}`,
      date: iso,
      weekday: WEEKDAYS[cur.getDay()] ?? '—',
    });
    cur.setDate(cur.getDate() + 1);
    index += 1;
  }
  return days;
}

export function countDaysInclusive(start: string, end: string): number {
  if (!start || !end) return 0;
  const s = new Date(start);
  const e = new Date(end);
  if (Number.isNaN(s.getTime()) || Number.isNaN(e.getTime()) || e < s) return 0;
  return Math.round((e.getTime() - s.getTime()) / 86400000) + 1;
}
